export default __webpack_public_path__ + "static/media/uploader-ascensiaContour-4.6f734f9a.png";